import PropTypes from 'prop-types';
import React from 'react';

class SlideShowItem extends React.PureComponent {
  static propTypes = {
    image: PropTypes.object.isRequired
  };

  render() {
    const { image } = this.props;

    if (!image.get('arquivo')) {
      return null;
    }

    const key =
      image.get('id') +
      '_' +
      image.get('exercicio') +
      '_' +
      image.get('entidade') +
      '_' +
      image.get('acompanhamento') +
      '_' +
      image.get('idOrdemServico');

    return (
      <div key={key}>
        <img src={'data:image/*;base64,' + image.get('arquivo')} />
      </div>
    );
  }
}

export default SlideShowItem;
